import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class MatPaginatorIntlService extends MatPaginatorIntl {
  constructor(private readonly translate: TranslateService) {
    super();
    this.translateLabels();
    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.translate.instant('paginator.of')} ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} ${this.translate.instant('paginator.of')} ${length}`;
  };

  private translateLabels(): void {
    this.itemsPerPageLabel = this.translate.instant('paginator.items_per_page');
    this.nextPageLabel = this.translate.instant('paginator.next_page');
    this.previousPageLabel = this.translate.instant('paginator.previous_page');
    this.firstPageLabel = this.translate.instant('paginator.first_page');
    this.lastPageLabel = this.translate.instant('paginator.last_page');
    this.changes.next();
  }
}
